module.exports = "<div [chart]=\"chart\"></div>\n"